import $http from '@/config/request';

//获取用户信息
export const getUserInfo = id => {
  return $http.get(`/user/userInfo/getUserInfo?userNo=${ id }`);
};

//上传图片
// export const uploadImage = params => {
//   return $http.post('/upload/mfileUpload', params);
// };
//获取验证码
export const getCode = params => {
  return $http.post('/g12eLogin/login/sendMsg', params);
};

//绑定手机号（用户未绑定）
export const bindMobile = params => {
  return $http.post('/user/login/mobileBind', params);
};

//验证原手机号
export const oldMobile = params => {
  return $http.post('/g12eLogin/login/checkPhone', params);
};

//绑定新手机号
export const updateMobile = params => {
  return $http.post('/g12eLogin/login/changePhone', params);
};
